module.exports = __webpack_public_path__ + "static/img/7.771bf01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/7.png
// module id = sQcb
// module chunks = 0